var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.62449 17.1973C6.44207 17.1057 6.2418 17.0741 6.04316 17.1211C5.36777 17.28 4.27807 17.5517 3.48511 17.7511C3.03431 17.8646 2.62405 17.4632 2.72864 17.0108C2.92567 16.1562 3.1989 14.9677 3.32862 14.3733C3.36917 14.1885 3.34403 13.9979 3.26377 13.8268C2.78864 12.8093 2.5 11.6832 2.5 10.5002C2.5 5.90705 6.68449 2.24389 11.4293 3.13414C14.4105 3.69358 16.8064 6.09028 17.3658 9.07075C18.2561 13.8155 14.5929 18 9.99983 18C8.825 18 7.65096 17.7162 6.62449 17.1973Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16746 7.55069C6.01208 8.71174 6.88773 10.5563 8.42825 12.0968C9.96875 13.6373 11.7841 14.4838 12.9452 13.3284L13.0522 13.2213C13.5176 12.7568 13.4495 11.9841 12.9103 11.6079C12.736 11.4871 12.5536 11.359 12.3597 11.2236C11.9406 10.9293 11.3673 10.9747 11.0049 11.3354L10.8087 11.5301C9.96466 11.0273 9.53658 10.5441 8.96658 9.68793L9.16117 9.49176C9.52117 9.12851 9.56658 8.55526 9.27308 8.13608C9.13683 7.9423 9.00958 7.75988 8.888 7.58556C8.51258 7.04638 7.73987 6.97908 7.27448 7.44367L7.16746 7.55069Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.508e6d0ba7c7e041f598ecf790ad8c7a.svg";
export { ForwardRef as ReactComponent };